export { default } from './AssignRolesPermissions.js';